module.exports = __webpack_public_path__ + "fonts/MaoKenShiJinHei-2.7420ac51.ttf";